import { sendElementClickedEvent } from '../bankrate-tracking/bankrate-reviews'

// Add sidebar filtering, dropdown, and Icon managment
let searchBanksInput = document.getElementById('searchBanksInput')
let filteredList = document.getElementById('filteredBankList')
let banks = Array.from(document.querySelectorAll('.review-filter-item'))
let searchIcon = document.getElementById('review-filter-search-icon')
let searchIconClose = document.getElementById(
  'review-filter-search-icon--close'
)

if (searchBanksInput) {
  searchBanksInput.addEventListener('keyup', filterBanks)
}

function filterBanks(e) {
  // create bankObjects array of objects and pass the DOM node so we can re-sort them later
  let bankObjects = banks.map(node => ({
    name: node.getAttribute('data-brand'),
    score: 0,
    node
  }))

  bankObjects.forEach(bank => {
    let start = new RegExp(`^${e.target.value}`, 'i')
    let middle = new RegExp(`.${e.target.value}`, 'i')
    // target exact matches of entire bank phrase
    let startMatch = !!bank.name.match(start)
    let middleMatch = !!bank.name.match(middle)
    // add score where phrases matched at beginning are weighted heavier
    bank.score += 1000 * (Number(startMatch) * 100)
    bank.score += 1000 * (Number(middleMatch) * 1)

    bank.name.split(' ').forEach((word, index) => {
      let startMatch = !!word.match(start)
      let middleMatch = !!word.match(middle)
      bank.score += (100 - index) * (Number(startMatch) * 100)
      bank.score += (100 - index) * (Number(middleMatch) * 1)
    })
  })
  // return sorted result based on score of phrase and filter out non-matches
  let result = bankObjects
    .filter(bank => bank.score > 0)
    .sort((a, b) => b.score - a.score)

  displaySearchResults(result)
}

function displaySearchResults(result) {
  // remove existing list
  filteredList.innerHTML = ''
  // repopulate list with newly sorted items if a user has entered a search value
  filteredList.style.display = 'block'
  let dropdownPosition = 1

  result.forEach(item => {
    item.node.style.display = 'block'
    filteredList.appendChild(item.node)
    item.node.dataset.count = dropdownPosition++
    item.node.addEventListener('click', sendElementClickedEvent)
  })
  // hide list if no results exist and no value is inputted
  if (searchBanksInput.value && result.length) {
    filteredList.style.display = 'block'
  } else {
    filteredList.style.display = 'none'
  }

  // If the list is open, show the X else show search icon
  if (filteredList.offsetHeight > 0) {
    searchIcon.style.display = 'none'
    searchIconClose.style.display = 'block'
  } else {
    searchIconClose.style.display = 'none'
    searchIcon.style.display = 'block'
  }
}

// Hide sidebar filtering dropdown if user clicks out off filtering and switch the Icon
function hideDropdown() {
  filteredList.style.display = 'none'
  searchIconClose.style.display = 'none'
  searchIcon.style.display = 'block'
}
if (searchBanksInput) {
  document.body.onclick = hideDropdown
}
